// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991.98px) {
  .navbar #debater-search-input {
    height: auto;
  }
  .navbar .container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    min-height: 3.5rem;
    padding: 0 0.5rem;
  }
  .navbar .navbar-brand {
    margin: 0 auto;
    font-size: 1.5rem;
    letter-spacing: -0.01em;
  }
  .navbar .navbar-toggler {
    position: absolute;
    left: 0.75rem;
    display: grid;
    place-items: center;
    padding: 0.65rem 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.32);
    background-image: none;
    color: inherit;
    box-shadow: none;
    transition: all 120ms ease;
    z-index: 1051;
  }
  .navbar .navbar-toggler:hover {
    background: #0570d0;
    border-color: rgba(255, 255, 255, 0.42);
  }
  .navbar .navbar-toggler:focus-visible {
    outline-offset: 3px;
  }
  .navbar .navbar-toggler:active {
    transform: scale(0.96);
  }
  .navbar .navbar-toggler .navbar-toggler-icon {
    width: 1.5em;
    height: 1.5em;
  }
  .navbar .navbar-collapse {
    position: fixed;
    inset: 0 auto 0 0;
    width: 66.67vw;
    height: 100vh;
    display: flex !important;
    flex-direction: column;
    gap: 1rem;
    padding: 3.5rem 1.5rem 2.5rem;
    margin: 0;
    background: #045fb0;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    box-shadow: 4px 0 10px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    transform: translateX(-102%);
    transition: transform 140ms cubic-bezier(0.33, 1, 0.68, 1);
    pointer-events: none;
    visibility: hidden;
    z-index: 1050;
  }
  .navbar .navbar-collapse::after {
    content: "";
    position: fixed;
    inset: 0;
    opacity: 0;
    background: rgba(0, 0, 0, 0.4);
    transition: opacity 140ms ease;
    pointer-events: none;
    z-index: -1;
  }
  .navbar .navbar-collapse.show {
    transform: translateX(0);
    pointer-events: auto;
    visibility: visible;
  }
  .navbar .navbar-collapse.show::after {
    pointer-events: auto;
  }
  .navbar .navbar-collapse.collapsing {
    height: 100% !important;
    transition: transform 140ms cubic-bezier(0.33, 1, 0.68, 1) !important;
    transform: translateX(-102%);
    pointer-events: none;
    visibility: hidden;
  }
  .navbar .navbar-collapse.collapsing::after {
    opacity: 0;
    pointer-events: none;
  }
  .navbar .navbar-nav {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0;
    margin: 0;
    width: 100%;
    color: rgba(255, 255, 255, 0.85);
  }
  .navbar .navbar-nav.mr-auto, .navbar .navbar-nav.ml-auto {
    margin: 0;
  }
  .navbar .navbar-nav + .navbar-nav {
    padding-top: 1rem;
    margin-top: 1rem;
  }
  .navbar .nav-item {
    list-style: none;
  }
  .navbar .nav-item .nav-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.65rem;
    padding: 0.75rem 1rem;
    font-size: 2.7rem;
    font-weight: 600;
    color: rgb(255, 255, 255);
    background: transparent;
    border: none;
    border-radius: 8px;
    width: 100%;
    transition: background 140ms ease;
  }
  .navbar .nav-item .nav-link:hover, .navbar .nav-item .nav-link:focus-visible {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
  .navbar .nav-item .nav-link:focus-visible {
    outline-offset: 2px;
  }
  .navbar .nav-item .nav-link.active {
    color: #fff;
    background: rgba(0, 0, 0, 0.2);
  }
  .navbar .dropdown-toggle::after {
    margin-left: auto;
    opacity: 0.55;
    transform: translateX(0.25rem);
  }
  .navbar .dropdown-menu {
    position: static;
    display: none;
    float: none;
    width: 100%;
    padding: 0.5rem;
    margin: 0.25rem 0;
    background: rgba(0, 0, 0, 0.15);
    border: none;
    border-radius: 12px;
    box-shadow: none;
  }
  .navbar .dropdown-menu.show {
    display: block;
  }
  .navbar .dropdown-item {
    padding: 0.75rem 1rem;
    font-size: 2.4rem;
    font-weight: 500;
    color: rgb(255, 255, 255);
    white-space: normal;
    border-radius: 8px;
    transition: background 140ms ease;
  }
  .navbar .dropdown-item:hover, .navbar .dropdown-item:focus-visible {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
  .navbar .dropdown-item:focus-visible {
    outline-offset: 2px;
  }
  .navbar .dropdown-item.active {
    color: #fff;
    background: rgba(0, 0, 0, 0.2);
  }
  .navbar .form-inline {
    width: 100%;
    margin: 1rem 0;
  }
  .navbar .form-inline .input-group {
    width: 100%;
  }
  .navbar .form-inline .input-group .form-control {
    flex: 1;
    font-size: 2.4rem;
    padding: 1rem 1.3rem;
    border-radius: 0.5rem !important;
  }
  .navbar .form-inline .input-group .btn {
    font-size: 2.4rem;
    padding: 1rem 1.3rem;
    border-radius: 0.5rem !important;
  }
  .navbar .form-inline .input-group .input-group-append .btn {
    border-radius: 0.5rem !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .navbar .navbar-toggler,
  .navbar .navbar-collapse,
  .navbar .nav-link,
  .navbar .dropdown-item {
    transition-duration: 0.01ms !important;
  }
  .navbar .navbar-collapse::after {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./apda/assets/css/navigation.scss"],"names":[],"mappings":"AACA;EAGI;IACE,YAAA;EAFJ;EAME;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;IACA,iBAAA;EAJJ;EAOE;IACE,cAAA;IACA,iBAAA;IACA,uBAAA;EALJ;EAQE;IACE,kBAAA;IACA,aAAA;IACA,aAAA;IACA,mBAAA;IACA,wBAAA;IACA,2CAAA;IACA,sBAAA;IACA,cAAA;IACA,gBAAA;IACA,0BAAA;IACA,aAAA;EANJ;EAQI;IACE,mBAAA;IACA,uCAAA;EANN;EASI;IACE,mBAAA;EAPN;EAUI;IACE,sBAAA;EARN;EAWI;IACE,YAAA;IACA,aAAA;EATN;EAaE;IACE,eAAA;IACA,iBAAA;IACA,cAAA;IACA,aAAA;IACA,wBAAA;IACA,sBAAA;IACA,SAAA;IACA,6BAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,gCAAA;IACA,yCAAA;IACA,gBAAA;IACA,4BAAA;IACA,0DAAA;IACA,oBAAA;IACA,kBAAA;IACA,aAAA;EAXJ;EAaI;IACE,WAAA;IACA,eAAA;IACA,QAAA;IACA,UAAA;IACA,8BAAA;IACA,8BAAA;IACA,oBAAA;IACA,WAAA;EAXN;EAcI;IACE,wBAAA;IACA,oBAAA;IACA,mBAAA;EAZN;EAcM;IACE,oBAAA;EAZR;EAgBI;IACE,uBAAA;IACA,qEAAA;IACA,4BAAA;IACA,oBAAA;IACA,kBAAA;EAdN;EAgBM;IACE,UAAA;IACA,oBAAA;EAdR;EAmBE;IACE,aAAA;IACA,sBAAA;IACA,WAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;IACA,gCAAA;EAjBJ;EAmBI;IAEE,SAAA;EAlBN;EAqBI;IACE,iBAAA;IACA,gBAAA;EAnBN;EAuBE;IACE,gBAAA;EArBJ;EAuBI;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,YAAA;IACA,qBAAA;IACA,iBAAA;IACA,gBAAA;IACA,yBAAA;IACA,uBAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;IACA,iCAAA;EArBN;EAuBM;IAEE,WAAA;IACA,oCAAA;EAtBR;EAyBM;IACE,mBAAA;EAvBR;EA0BM;IACE,WAAA;IACA,8BAAA;EAxBR;EA6BE;IACE,iBAAA;IACA,aAAA;IACA,8BAAA;EA3BJ;EA8BE;IACE,gBAAA;IACA,aAAA;IACA,WAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,+BAAA;IACA,YAAA;IACA,mBAAA;IACA,gBAAA;EA5BJ;EA8BI;IACE,cAAA;EA5BN;EAgCE;IACE,qBAAA;IACA,iBAAA;IACA,gBAAA;IACA,yBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iCAAA;EA9BJ;EAgCI;IAEE,WAAA;IACA,oCAAA;EA/BN;EAkCI;IACE,mBAAA;EAhCN;EAmCI;IACE,WAAA;IACA,8BAAA;EAjCN;EAsCE;IACE,WAAA;IACA,cAAA;EApCJ;EAsCI;IACE,WAAA;EApCN;EAsCM;IACE,OAAA;IACA,iBAAA;IACA,oBAAA;IACA,gCAAA;EApCR;EAuCM;IACE,iBAAA;IACA,oBAAA;IACA,gCAAA;EArCR;EAyCQ;IACE,gCAAA;EAvCV;AACF;AA+CA;EACE;;;;IAIE,sCAAA;EA7CF;EAgDA;IACE,gBAAA;EA9CF;AACF","sourcesContent":["// Mobile navigation styles\n@media (max-width: 991.98px) {\n  .navbar {\n\n    #debater-search-input {\n      height: auto;\n    }\n\n    \n    .container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 1rem;\n      min-height: 3.5rem;\n      padding: 0 0.5rem;\n    }\n\n    .navbar-brand {\n      margin: 0 auto;\n      font-size: 1.5rem;\n      letter-spacing: -0.01em;\n    }\n\n    .navbar-toggler {\n      position: absolute;\n      left: 0.75rem;\n      display: grid;\n      place-items: center;\n      padding: 0.65rem 0.75rem;\n      border: 1px solid rgba(255, 255, 255, 0.32);\n      background-image: none;\n      color: inherit;\n      box-shadow: none;\n      transition: all 120ms ease;\n      z-index: 1051;\n\n      &:hover {\n        background: #0570d0;\n        border-color: rgba(255, 255, 255, 0.42);\n      }\n\n      &:focus-visible {\n        outline-offset: 3px;\n      }\n\n      &:active {\n        transform: scale(0.96);\n      }\n\n      .navbar-toggler-icon {\n        width: 1.5em;\n        height: 1.5em;\n      }\n    }\n\n    .navbar-collapse {\n      position: fixed;\n      inset: 0 auto 0 0;\n      width: 66.67vw;\n      height: 100vh;\n      display: flex !important;\n      flex-direction: column;\n      gap: 1rem;\n      padding: 3.5rem 1.5rem 2.5rem;\n      margin: 0;\n      background: #045fb0;\n      border-top-right-radius: 25px;\n      border-bottom-right-radius: 25px;\n      box-shadow: 4px 0 10px rgba(0, 0, 0, 0.2);\n      overflow-y: auto;\n      transform: translateX(-102%);\n      transition: transform 140ms cubic-bezier(0.33, 1, 0.68, 1);\n      pointer-events: none;\n      visibility: hidden;\n      z-index: 1050;\n\n      &::after {\n        content: \"\";\n        position: fixed;\n        inset: 0;\n        opacity: 0;\n        background: rgba(0, 0, 0, 0.4);\n        transition: opacity 140ms ease;\n        pointer-events: none;\n        z-index: -1;\n      }\n\n      &.show {\n        transform: translateX(0);\n        pointer-events: auto;\n        visibility: visible;\n\n        &::after {\n          pointer-events: auto;\n        }\n      }\n\n      &.collapsing {\n        height: 100% !important;\n        transition: transform 140ms cubic-bezier(0.33, 1, 0.68, 1) !important;\n        transform: translateX(-102%);\n        pointer-events: none;\n        visibility: hidden;\n\n        &::after {\n          opacity: 0;\n          pointer-events: none;\n        }\n      }\n    }\n\n    .navbar-nav {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      padding: 0;\n      margin: 0;\n      width: 100%;\n      color: rgba(255, 255, 255, 0.85);\n\n      &.mr-auto,\n      &.ml-auto {\n        margin: 0;\n      }\n\n      + .navbar-nav {\n        padding-top: 1rem;\n        margin-top: 1rem;\n      }\n    }\n\n    .nav-item {\n      list-style: none;\n\n      .nav-link {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 0.65rem;\n        padding: 0.75rem 1rem;\n        font-size: 2.7rem;\n        font-weight: 600;\n        color: rgba(255, 255, 255, 1);\n        background: transparent;\n        border: none;\n        border-radius: 8px;\n        width: 100%;\n        transition: background 140ms ease;\n\n        &:hover,\n        &:focus-visible {\n          color: #fff;\n          background: rgba(255, 255, 255, 0.1);\n        }\n\n        &:focus-visible {\n          outline-offset: 2px;\n        }\n\n        &.active {\n          color: #fff;\n          background: rgba(0, 0, 0, 0.2);\n        }\n      }\n    }\n\n    .dropdown-toggle::after {\n      margin-left: auto;\n      opacity: 0.55;\n      transform: translateX(0.25rem);\n    }\n\n    .dropdown-menu {\n      position: static;\n      display: none;\n      float: none;\n      width: 100%;\n      padding: 0.5rem;\n      margin: 0.25rem 0;\n      background: rgba(0, 0, 0, 0.15);\n      border: none;\n      border-radius: 12px;\n      box-shadow: none;\n\n      &.show {\n        display: block;\n      }\n    }\n\n    .dropdown-item {\n      padding: 0.75rem 1rem;\n      font-size: 2.4rem;\n      font-weight: 500;\n      color: rgba(255, 255, 255, 1);\n      white-space: normal;\n      border-radius: 8px;\n      transition: background 140ms ease;\n\n      &:hover,\n      &:focus-visible {\n        color: #fff;\n        background: rgba(255, 255, 255, 0.1);\n      }\n\n      &:focus-visible {\n        outline-offset: 2px;\n      }\n\n      &.active {\n        color: #fff;\n        background: rgba(0, 0, 0, 0.2);\n      }\n    }\n\n    // Keep search form visible in mobile nav\n    .form-inline {\n      width: 100%;\n      margin: 1rem 0;\n      \n      .input-group {\n        width: 100%;\n        \n        .form-control {\n          flex: 1;\n          font-size: 2.4rem;\n          padding: 1rem 1.3rem;\n          border-radius: .5rem !important;\n        }\n\n        .btn {\n          font-size: 2.4rem;\n          padding: 1rem 1.3rem;\n          border-radius: .5rem !important;\n        }\n\n        .input-group-append {\n          .btn {\n            border-radius: .5rem !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Reduced motion support\n@media (prefers-reduced-motion: reduce) {\n  .navbar .navbar-toggler,\n  .navbar .navbar-collapse,\n  .navbar .nav-link,\n  .navbar .dropdown-item {\n    transition-duration: 0.01ms !important;\n  }\n\n  .navbar .navbar-collapse::after {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
